export const ACCOUNT_SET_ELEMENTS = 'ACCOUNT_SET_ELEMENTS';
export const ACCOUNT_SET_DETAILS = 'ACCOUNT_SET_DETAILS';
export const ACCOUNT_CLEAR_ELEMENTS = 'ACCOUNT_CLEAR_ELEMENTS';
export const ACCOUNT_SET_LAST_PAGE = 'ACCOUNT_SET_LAST_PAGE';